export const batchList = "BATCH_LIST";
export const activeCourseNameList = "ACTIVE_COURSE_NAME_LIST";
export const courseEnrollmentList = "COURSE_ENROLLMENT_LIST";
